import React, { useEffect, useState } from "react";
import LanguageValueField from "./LanguageValueField";
import SimpleTextField from "./SimpleTextField";
import AutocompleteSingle from "./AutocompleteSingle";
import { Typography, Stack } from "@mui/material";
import Address from "../formModels/Address";
import { isFieldRequired, getTitleByField, getDescriptionByField } from "../config/commonFunctions";
import LanguageValueList from "../formModels/LanguageValueList";

export default function AddressView(props) {
    const { address, handleChange, lang, countryOptions, schemaAsObject, required, title, error } = props;
    const [localAddress, setLocalAddress] = useState(address);
    // console.log(title, address);
    // console.log(error);
    useEffect(() => {
        setLocalAddress(address); // Update local state when address changes
    }, [address]);

    // Update function for street address field
    const updateStreetAddressField = (updatedValues) => {
        if (updatedValues instanceof LanguageValueList) {
            // const newStreetAddress = new LanguageValueList(updatedValues);
            const updatedAddress = new Address(
                updatedValues,  // Update street address
                localAddress.getAdministrativeArea(), // Keep other fields the same
                localAddress.getCity(),
                localAddress.getPostalCode(),
                localAddress.getCountry(),
                localAddress.getId(),
            );
            setLocalAddress(updatedAddress);
            handleChange(updatedAddress);
        }
    };

    // Update function for administrative area field
    const updateAdministrativeAreaField = (updatedValues) => {
        if (updatedValues instanceof LanguageValueList) {
            const updatedAddress = new Address(
                localAddress.getStreetAddress(),  // Keep other fields the same
                updatedValues,
                localAddress.getCity(),
                localAddress.getPostalCode(),
                localAddress.getCountry(),
                localAddress.getId(),
            );
            setLocalAddress(updatedAddress);
            handleChange(updatedAddress);
        }
    };

    // Update function for city field
    const updateCityField = (updatedValues) => {
        if (updatedValues instanceof LanguageValueList) {
            const updatedAddress = new Address(
                localAddress.getStreetAddress(),
                localAddress.getAdministrativeArea(), // Keep other fields the same
                updatedValues,
                localAddress.getPostalCode(),
                localAddress.getCountry(),
                localAddress.getId(),
            );
            setLocalAddress(updatedAddress);
            handleChange(updatedAddress);
        }
    };

    const updatePostalCodeField = (newPostalCode) => {
        const updatedAddress = new Address(
            localAddress.getStreetAddress(),
            localAddress.getAdministrativeArea(),
            localAddress.getCity(),
            newPostalCode, // Update postal code
            localAddress.getCountry(),
            localAddress.getId(),
        );
        setLocalAddress(updatedAddress);
        handleChange(updatedAddress);
    };

    const updateCountryField = (newCountry) => {
        const updatedAddress = new Address(
            localAddress.getStreetAddress(),
            localAddress.getAdministrativeArea(),
            localAddress.getCity(),
            localAddress.getPostalCode(),
            newCountry, // Update country
            localAddress.getId(),
        );
        setLocalAddress(updatedAddress);
        handleChange(updatedAddress);
    };

    return (
        <Stack spacing={2}>
            <fieldset>
                <legend>
                    {required ? (<div>
                        <Typography variant="h6">{title}<span>*</span></Typography>
                    </div>) : (<Typography variant="h6">{title}</Typography>)}
                </legend>
                <Typography variant="p">{props.subtitle}</Typography>
                <Stack spacing={2} sx={{pt: 2}}>
                    <LanguageValueField
                        // label="Street Address"
                        label={getTitleByField(schemaAsObject, "Address.street_address")}
                        helperText={getDescriptionByField(schemaAsObject, "Address.street_address")}
                        obj={localAddress.getStreetAddress()}
                        lang={lang}
                        required={required ? isFieldRequired("street_address", schemaAsObject?.$defs?.Address) : false}
                        onChange={updateStreetAddressField}
                        // error={error ? !!error.street_address : false}
                    />

                    <LanguageValueField
                        label={getTitleByField(schemaAsObject, "Address.city")}
                        helperText={getDescriptionByField(schemaAsObject, "Address.city")}
                        obj={localAddress.getCity()}
                        lang={lang}
                        required={required ? isFieldRequired("city", schemaAsObject?.$defs?.Address) : false}
                        onChange={updateCityField}
                        // error={error ? !!error.city : false}
                    />

                    <LanguageValueField
                        label={getTitleByField(schemaAsObject, "Address.administrative_area")}
                        helperText={getDescriptionByField(schemaAsObject, "Address.administrative_area")}
                        obj={localAddress.getAdministrativeArea()}
                        lang={lang}
                        required={required ? isFieldRequired("administrative_area", schemaAsObject?.$defs?.Address) : false}
                        onChange={updateAdministrativeAreaField}
                        // error={error ? !!error.administrative_area : false}
                    />

                    <SimpleTextField
                        label={getTitleByField(schemaAsObject, "Address.postal_code")}
                        helperText={getDescriptionByField(schemaAsObject, "Address.postal_code")}
                        value={localAddress.getPostalCode()}
                        onChange={updatePostalCodeField}
                        required={required ? isFieldRequired("postal_code", schemaAsObject?.$defs?.Address) : false}
                        // error={error ? !!error.postal_code : false}
                    />
                    <AutocompleteSingle
                        title={getTitleByField(schemaAsObject, "Address.country")}
                        helperText={getDescriptionByField(schemaAsObject, "Address.country")}
                        options={countryOptions}
                        onChange={updateCountryField}
                        required={required ? isFieldRequired("country", schemaAsObject?.$defs?.Address) : false}
                        // onChange={(value) => handleChange("company_type", value)}
                        value={
                            address.country
                                ? countryOptions.find(option => option.value === address.country)
                                : null // If no prepopulated data, set to null to display empty field
                        }
                        // error={error ? !!error.country : false}
                    />
                </Stack>
            </fieldset>
        </Stack>
    );
}
